import { ApolloError } from "@apollo/client";

// The codes the integration API refuses a save with; each has a message.
const KNOWN_ERROR_CODES = new Set([
  "placetel-organization-id-invalid",
  "placetel-client-id-invalid",
  "placetel-client-secret-invalid",
  "placetel-client-secret-required",
  "placetel-refresh-token-invalid",
  "placetel-refresh-token-required",
  "placetel-webhook-secret-invalid",
  "placetel-webhook-secret-required",
  "placetel-phone-client-id-invalid",
  "placetel-phone-client-secret-invalid",
  "placetel-phone-client-secret-required",
]);

// The message key for a refused save; null for an unexpected error.
export const placetelIntegrationErrorKey = (error: unknown): string | null => {
  const code = error instanceof ApolloError ? error.graphQLErrors[0]?.message : undefined;
  return code && KNOWN_ERROR_CODES.has(code) ? `integrations.placetel.errors.${code}` : null;
};
